import bossApi from '../../utils/fetch-api';

const DEFAULT_OPTIONS = { m2m: true, authScope: process.env.BOSS_API_AUTH_SCOPE_ORDER };

export const getAccountInvoices = async ({
  accountId,
  locale,
  token,
}: {
  accountId: string;
  locale: string;
  token: string;
}) => {
  return bossApi<{ invoices: { invoice: string; amounttopay: number }[] }>(
    `/account/v2/accounts/${accountId}/invoices?paid=false&limit=100`,
    {
      m2m: false,
      locale,
      token,
    },
  );
};

export const updateInvoicePaymentStatus = async ({
  invoiceId,
  timeStamp,
  paid,
  paymentReference,
  locale,
}: {
  invoiceId: string;
  timeStamp: string;
  paid: boolean;
  paymentReference?: string;
  locale: string;
}) => {
  return bossApi(`/order/v2/invoices/${invoiceId}`, {
    ...DEFAULT_OPTIONS,
    locale,
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json-patch+json',
    },
    body: [
      {
        path: 'invoiceonlinepayed',
        op: 'replace',
        value: paid,
      },
      {
        path: 'paymentreference',
        op: 'replace',
        value: paymentReference,
      },
      {
        path: 'paymenttimestamp',
        op: 'replace',
        value: timeStamp,
      },
    ],
  });
};
